import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
const GlobalNews = () => {
  const { t } = useTranslation();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const limit = 20;

  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `/api/get_global_news.php?page=${page}&limit=${limit}`
        );
        const data = await response.json();
        if (data.success) {
          setNews(data.news);
          setTotalPages(data.totalPages);
        } else {
          setNews([]);
        }
      } catch (err) {
        console.error("Ошибка при загрузке новостей:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [page]);

  return (
    <section className="p-6 w-full opacity-0 animate-[showtitle_1s_forwards] flex flex-col items-center">
      <h1 className="text-4xl max-sm:text-2xl opacity-0 animate-[showtitle_1s_forwards] delay-300 text-left w-full text-white font-bold mb-6 uppercase">
        {t("news")}
      </h1>

      {loading ? (
        <p className="text-white text-lg animate-pulse">{t("loading")}...</p>
      ) : news.length === 0 ? (
        <p className="text-white text-lg">
          {t("nonews") || "Նորություններ չկան"}
        </p>
      ) : (
        <div className="w-full mt-6 flex flex-wrap gap-6 justify-start">
          {news.map((item) => (
            <article
              key={item.id}
              className="w-[420px] bg-white rounded-2xl overflow-hidden shadow-lg "
            >
              {/* Обложка */}
              <img
                src={`/api/uploads/${item.image}`}
                alt={item.title}
                className="w-full h-[220px] object-cover"
              />

              {/* Лого и компания */}
              <div className="flex items-center gap-3 px-4 mt-3">
                <img
                  src={
                    item.companyLogo
                      ? `/api/uploads/${item.companyLogo}`
                      : "https://img.freepik.com/free-vector/bird-colorful-logo-gradient-vector_343694-1365.jpg"
                  }
                  alt={item.companyName}
                  className="w-[80px] h-[80px] absolute top-[280px] bg-white rounded-2xl object-cover border border-gray-300 shadow-md"
                />

                <h3 className="text-lg font-semibold mt-6 text-[#006674]">
                  {item.companyName || "Unknown Company"}
                </h3>
              </div>

              {/* Заголовок и описание */}
              <div className="px-4 pb-4 flex flex-col gap-2">
                <h2 className="text-2xl max-sm:text-lg font-bold uppercase">{item.title}</h2>
                <p className="text-gray-600 line-clamp-3">{item.description}</p>
              </div>

              {/* Нижняя панель */}
              <div className="flex w-full p-3 bg-[#006674] text-white justify-between items-center">
                <span className="text-sm">
                  {new Date(item.created_at).toLocaleDateString()}
                </span>
                <Link
                  to={`/News/${item.id}`}
                  className="font-semibold hover:underline"
                >
                  {t("readmore")}
                </Link>
              </div>
            </article>
          ))}
        </div>
      )}
      {/* <div className="flex gap-2 mt-10">
        <button
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
          className={`w-[40px] h-[40px] rounded-full ${
            page === 1
              ? "bg-white text-[#006674] cursor-not-allowed"
              : "bg-[#006674] text-white hover:bg-[#00555a]"
          }`}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </button>

        <span className="text-white px-3 py-2">
          {page} / {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
          className={`w-[40px] h-[40px] rounded-full ${
            page === totalPages
              ? "bg-white text-[#006674] cursor-not-allowed"
              : "bg-[#006674] text-white hover:bg-[#00555a]"
          }`}
        >
          <FontAwesomeIcon icon={faAngleRight} />
        </button>
      </div>
      <div className="flex gap-2 mt-10">
        <button
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
          className={`w-[40px] h-[40px] rounded-full ${
            page === 1
              ? "bg-[#006674] text-white cursor-not-allowed"
              : "bg-[#006674] text-white hover:bg-[#00555a]"
          }`}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </button>

        <span className="text-white px-3 py-2">
          {page} / {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
          className={`w-[40px] h-[40px] rounded-full ${
            page === totalPages
              ? "bg-[#006674] text-white cursor-not-allowed"
              : "bg-[#006674] text-white hover:bg-[#00555a]"
          }`}
        >
          <FontAwesomeIcon icon={faAngleRight} />
        </button>
      </div> */}
      {/* Пагинация */}
      {totalPages > 1 && (
        <div className="flex gap-2 mt-10">
          <button
            disabled={page === 1}
            onClick={() => setPage((p) => p - 1)}
            className={`px-4 py-2 rounded ${
              page === 1
                ? "bg-gray-400 text-white cursor-not-allowed"
                : "bg-[#006674] text-white hover:bg-[#00555a]"
            }`}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </button>

          <span className="text-white px-3 py-2">
            {page} / {totalPages}
          </span>

          <button
            disabled={page === totalPages}
            onClick={() => setPage((p) => p + 1)}
            className={`px-4 py-2 rounded ${
              page === totalPages
                ? "bg-gray-400 text-white cursor-not-allowed"
                : "bg-[#006674] text-white hover:bg-[#00555a]"
            }`}
          >
            <FontAwesomeIcon icon={faAngleRight} />
          </button>
        </div>
      )}
    </section>
  );
};

export default GlobalNews;
